import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Paper, Tab, Box } from '@mui/material'
import { useEffect, useState } from 'react'
import DashboardIcon from '@mui/icons-material/Dashboard';
import Dashboard from './Dashboard';
import "../css/style.css";
import Base from '../../Base/views/Base';
import AtsSettings from './AtsSettings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import AtsOnboarding from './AtsOnboarding';
import { useLocation } from "react-router-dom";
import FormBuilderLandingPage from './FormBuilderLandingPage';
import OfferLetterLandingPage from './OfferLetterLandingPage';
import AgreementSettingsLandingPage from './AgreementSettingsLandingPage';
import { useDispatch } from 'react-redux';
import { GetIndustryTypeAction } from "../../../../store/ATS/IndustryType/Action";
import { GetCandidateSourceAction } from "../../../../store/ATS/CandidateSource/Action";
import { GetSkillsAction } from "../../../../store/ATS/Skills/Action";
import { GetJobTemplateAction } from "../../../../store/ATS/JobTemplate/Action";
import { GetEmploymentTypeAction } from '../../../../store/Ancillary/EmploymentType/Action';
import { GetDocumentationsAction } from '../../../../store/Ancillary/Documentations/Action';
import { GetFormTemplateAction, GetOfferLetterTemplateAction } from '../../../../store/ATS/FormTemplate/Action';
import { GetCtcCategoryAction } from '../../../../store/ATS/CTCConfig/Action';
import { GetMprDetailsAction } from '../../../../store/ATS/HiringRequestConfig/Action';
import {GetMPRIDAction} from '../../../../store/ATS/MPRID/Action';
import { GetOfferLetterIDAction } from '../../../../store/ATS/OfferLetterID/Action';


const AtsSettingsLandingPage = () => {
    const location = useLocation();
    const defaultValue = location.state?.defaultValue || "";
    const [value, setValue] = useState(defaultValue? defaultValue : '1');
    const [accordian, setAccordian] = useState('1');
    const [hideHeaderTabs, setHideHeaderTabs] = useState(false);
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(GetIndustryTypeAction());
        dispatch(GetCandidateSourceAction());
        dispatch(GetSkillsAction({ industry_type_id: null }));
        dispatch(GetJobTemplateAction({ industry_type_id: null }));
        // dispatch(GetAtsDesignationAction());
        dispatch(GetEmploymentTypeAction());
        dispatch(GetDocumentationsAction());
        dispatch(GetFormTemplateAction());
        dispatch(GetCtcCategoryAction());
        dispatch(GetMprDetailsAction());
        dispatch(GetOfferLetterTemplateAction());
        dispatch(GetMPRIDAction());
        dispatch(GetOfferLetterIDAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue !== "5") {
            setHideHeaderTabs(false);
        }
    };
    return (
        <>
            <Base>
                <Paper className='ats-settings admin-setting' sx={{ borderRadius: "10px", minHeight: "87vh", maxHeight: "87vh", overflowY: "auto" }}>
                    <TabContext value={value}>
                        {!(value === "5" && hideHeaderTabs) && (
                            <Box
                                sx={{
                                position: "sticky",
                                top: 0,
                                zIndex: 100,
                                backgroundColor: "#ffffff", 
                            }}>
                                <TabList sx={{
                                    minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                                    '& .MuiTabs-indicator': {
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: "center !important",
                                    },
                                }} onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab icon={<DashboardIcon fontSize='small' />} iconPosition="start" label="Dashboard" value="1" />
                                    <Tab icon={<ManageAccountsIcon fontSize='small' />} iconPosition="start" label="ATS" value="2" />
                                    <Tab icon={<DirectionsBusIcon fontSize='small' />} iconPosition="start" label="Onboarding" value="3" />
                                    <Tab icon={<DynamicFeedIcon fontSize='small' />} iconPosition="start" label="Form Builder" value="4" />
                                    <Tab icon={<BusinessCenterIcon fontSize='small' />} iconPosition="start" label="Offer Letter" value="5" />
                                    <Tab icon={<HandshakeOutlinedIcon fontSize='small' />} iconPosition="start" label="Agreement" value="6" />
                                </TabList>
                            </Box>
                        )}
                        <TabPanel value="1" sx={{ padding: "0px", minHeight: "45px" }}>
                            <Dashboard setValue={setValue} setAccordian={setAccordian} />
                        </TabPanel>
                        <TabPanel value="2" sx={{ padding: "0px", minHeight: "45px" }}>
                            <AtsSettings accordian={accordian} />
                        </TabPanel>
                        <TabPanel value="3" sx={{ padding: "0px", minHeight: "45px" }}>
                            <AtsOnboarding accordian={accordian} />
                        </TabPanel>
                        <TabPanel value="4" sx={{ padding: "0px", minHeight: "45px" }}>
                            <FormBuilderLandingPage />
                        </TabPanel>
                        <TabPanel value="5" sx={{ padding: "0px", minHeight: "45px" }}>
                            <OfferLetterLandingPage onModeChange={setHideHeaderTabs} />
                        </TabPanel>
                        <TabPanel value="6" sx={{ padding: "0px", minHeight: "45px" }}>
                            <AgreementSettingsLandingPage />
                        </TabPanel>
                    </TabContext>
                </Paper>
            </Base>
        </>
    );
}


export default AtsSettingsLandingPage;
